import {useDocumentMeta} from "@firefly/fly-hook";
import PaymentClientContext, {PaymentClientContextType} from "./context/PaymentClientContext";
import { useMemo } from "react";
import {PaymentMethod} from "./typing";


export interface PaymentClientProviderProps {
    children: React.ReactElement;
}
function PaymentClientProvider(props: PaymentClientProviderProps) {
    const {
        children
    } = props;
    const target = useDocumentMeta(["firefly", "payment"])
    const PaymentClientContextValue = useMemo<PaymentClientContextType>(() => {
        return {
            defaultOptions: (method: PaymentMethod) => {
                let agent;
                if (method === 'WECHATPAY:H5' && target) {
                    if (target !== window.location.origin) {
                        agent = {
                            target: target
                        };
                    }
                }
                return {
                    agent,
                }
            }
        }
    }, [target])
    return <PaymentClientContext.Provider value={PaymentClientContextValue}>
        {children}
    </PaymentClientContext.Provider>
}

export default PaymentClientProvider;